import { getApp, getApps, initializeApp, type FirebaseApp, type FirebaseOptions } from "firebase/app";

const REQUIRED_KEYS = [
  "VITE_FIREBASE_API_KEY",
  "VITE_FIREBASE_AUTH_DOMAIN",
  "VITE_FIREBASE_PROJECT_ID",
  "VITE_FIREBASE_STORAGE_BUCKET",
  "VITE_FIREBASE_MESSAGING_SENDER_ID",
  "VITE_FIREBASE_APP_ID",
] as const;

type FirebaseEnvironment = Record<(typeof REQUIRED_KEYS)[number], string | undefined> & {
  VITE_FIREBASE_MEASUREMENT_ID?: string;
};

const VERIFIED_PUBLIC_OPTIONS: FirebaseOptions = {
  apiKey: "AIzaSyCQUMKETBEC1XvQvbZTAw_VU8ePgjVr1Oo",
  appId: "1:373241101974:web:a9d7c67c1c22876842ccb7",
  authDomain: "wordinariusecho.firebaseapp.com",
  measurementId: "G-V5V5ZQ3XRF",
  messagingSenderId: "373241101974",
  projectId: "wordinariusecho",
  storageBucket: "wordinariusecho.firebasestorage.app",
};

export function readFirebaseOptions(environment: FirebaseEnvironment): FirebaseOptions | null {
  if (REQUIRED_KEYS.some((key) => !environment[key]?.trim())) {
    return null;
  }
  if (environment.VITE_FIREBASE_PROJECT_ID !== "wordinariusecho") {
    throw new Error("firebase_project_mismatch");
  }
  if (environment.VITE_FIREBASE_APP_ID !== "1:373241101974:web:a9d7c67c1c22876842ccb7") {
    throw new Error("firebase_web_app_mismatch");
  }

  return {
    apiKey: environment.VITE_FIREBASE_API_KEY,
    appId: environment.VITE_FIREBASE_APP_ID,
    authDomain: environment.VITE_FIREBASE_AUTH_DOMAIN,
    measurementId: environment.VITE_FIREBASE_MEASUREMENT_ID,
    messagingSenderId: environment.VITE_FIREBASE_MESSAGING_SENDER_ID,
    projectId: environment.VITE_FIREBASE_PROJECT_ID,
    storageBucket: environment.VITE_FIREBASE_STORAGE_BUCKET,
  };
}

export function getWordinariusFirebaseApp(): FirebaseApp | null {
  const options = readFirebaseOptions(import.meta.env as unknown as FirebaseEnvironment)
    || VERIFIED_PUBLIC_OPTIONS;
  return getApps().length ? getApp() : initializeApp(options);
}
